<table mat-table [dataSource]="dataSource!" matSort class="mat-elevation-z8">

    <ng-container matColumnDef="blinkerChannel">
        <th mat-header-cell *matHeaderCellDef>Blinker Kanal </th>
        <td mat-cell *matCellDef="let element"> {{element.blinkerChannel}} </td>
    </ng-container>

    <ng-container matColumnDef="blinkerIndicator">
        <th mat-header-cell *matHeaderCellDef>Blinker Indiator </th>
        <td mat-cell *matCellDef="let element"> {{element.blinkerIndicator}} </td>
    </ng-container>
    <!-- deviceName -->
    <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef>Gerät</th>
        <td mat-cell *matCellDef="let element"> {{element.deviceName}} </td>
    </ng-container>
    <!-- 'duration', 'ledChannel', 'ledCode', 'ledIndicator', 'lineDescription', 'online', 'output', 'samId', 'timestampFrom', 
     'timestampTo', 'trigger', 'triggerName', 'triggerTimestamp', 'userId' -->
    <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef>Dauer</th>
        <td mat-cell *matCellDef="let element"> {{element.duration}} </td>
    </ng-container>
    <ng-container matColumnDef="ledChannel">
        <th mat-header-cell *matHeaderCellDef>LED Kanal</th>
        <td mat-cell *matCellDef="let element"> {{element.ledChannel}} </td>
    </ng-container>

    <ng-container matColumnDef="ledCode">
        <th mat-header-cell *matHeaderCellDef>LED Code</th>
        <td mat-cell *matCellDef="let element"> {{element.ledCode}} </td>
    </ng-container>

    <ng-container matColumnDef="ledIndicator">
        <th mat-header-cell *matHeaderCellDef>LED Anzeige</th>
        <td mat-cell *matCellDef="let element"> {{element.ledIndicator}} </td>
    </ng-container>

    <ng-container matColumnDef="lineDescription">
        <th mat-header-cell *matHeaderCellDef>Linienbeschreibung</th>
        <td mat-cell *matCellDef="let element"> {{element.lineDescription}} </td>
    </ng-container>

    <ng-container matColumnDef="online">
        <th mat-header-cell *matHeaderCellDef>Online</th>
        <td mat-cell *matCellDef="let element"> {{element.online}} </td>
    </ng-container>
    <!-- 'output', 'samId', 'timestampFrom', 
     'timestampTo', 'trigger',   -->
    <ng-container matColumnDef="output">
        <th mat-header-cell *matHeaderCellDef>Ausgang</th>
        <td mat-cell *matCellDef="let element"> {{element.output}} </td>
    </ng-container>
    <ng-container matColumnDef="samId">
        <th mat-header-cell *matHeaderCellDef>SAM ID</th>
        <td mat-cell *matCellDef="let element"> {{element.samId}} </td>
    </ng-container>

    <!-- timestampFrom', 
     'timestampTo -->

    <ng-container matColumnDef="timestampFrom">
        <th mat-header-cell *matHeaderCellDef>Von</th>
        <td mat-cell *matCellDef="let element"> {{element.timestampFrom| date: 'dd.MM.yyyy - H:mm'}} </td>
    </ng-container>
    <ng-container matColumnDef="timestampTo">
        <th mat-header-cell *matHeaderCellDef>Bis</th>
        <td mat-cell *matCellDef="let element"> {{element.timestampTo | date: 'dd.MM.yyyy - H:mm'}} </td>
    </ng-container>


    <ng-container matColumnDef="triggerTimestamp">
        <th mat-header-cell *matHeaderCellDef>Trigger Von</th>
        <td mat-cell *matCellDef="let element"> {{element.triggerTimestamp | date: 'dd.MM.yyyy - H:mm'}} </td>
    </ng-container>


    <ng-container matColumnDef="trigger">
        <th mat-header-cell *matHeaderCellDef>Trigger</th>
        <td mat-cell *matCellDef="let element"> {{element.trigger}} </td>
    </ng-container>

    <ng-container matColumnDef="triggerName">
        <th mat-header-cell *matHeaderCellDef>Trigger Name</th>
        <td mat-cell *matCellDef="let element"> {{element.triggerName}} </td>
    </ng-container>

    <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef>Benutzer ID</th>
        <td mat-cell *matCellDef="let element"> {{element.userId}} </td>
    </ng-container>




    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>